
async function loadBrandList() {
    console.log("loadBrandList");
    const formData = new FormData();
    formData.append('action', 'load-list-brand');

    $.ajax({
        url: '/apps/integration',
        method: 'POST',
        data: formData,
        processData: false, // prevent jQuery from converting the data
        contentType: false, // let the browser set the correct content type
        success: function(response) {
            console.log('Brand list loaded:', response);
            // Store the response globally to replace json_response_1
            window.brandListResponse = response.data;
            // Initialize global device selection object
            window.tradeinDeviceData = {
                brandList: response.data,
                selectedDevice: {
                    brand: '',
                    model: '',
                    variant: '',
                    device_id: null,
                    price: null,
                    currency: null
                },
                questionnaire: null,
                questionnaireAnswers: {},
                priceResult: null,
                locationData: null,
                selectedLocation: null
            };
            // Now render the first step after data is loaded
            setStep(1);
        },
        error: function(xhr, status, error) {
            console.error('Error loading brand list:', error);
        }
    });

}

async function loadQuestion() {
    console.log("loadQuestion");
    const formData = new FormData();
    formData.append('action', 'load-question');

    $.ajax({
        url: '/apps/integration',
        method: 'POST',
        data: formData,
        processData: false, // prevent jQuery from converting the data
        contentType: false, // let the browser set the correct content type
        success: function(response) {
            console.log('Question loaded:', response);
            // Store the questionnaire data globally
            window.tradeinDeviceData.questionnaire = response.data;
            // Now render the second step after data is loaded
            setStep(2);
        },
        error: function(xhr, status, error) {
            console.error('Error loading questions:', error);
        }
    });

}

async function calculatePrice() {
    //setStep(3);
    //return;
    console.log("calculatePrice");
    const payload = createPriceCalculationPayload();
    
    const formData = new FormData();
    formData.append('action', 'calculate-price');
    formData.append('deviceID', payload.deviceID);
    formData.append('question', JSON.stringify(payload.question));

    $.ajax({
        url: '/apps/integration',
        method: 'POST',
        data: formData,
        processData: false, // prevent jQuery from converting the data
        contentType: false, // let the browser set the correct content type
        success: function(response) {
            console.log('Price calculated:', response);
            if (response.api === true) {
                // Store the price calculation result globally
                window.tradeinDeviceData.priceResult = response.data;
                // Now render the third step after price is calculated
                setStep(3);
            } else {
                console.error('Price calculation failed:', response.msg);
                alert('Price calculation failed: ' + response.msg);
            }
        },
        error: function(xhr, status, error) {
            console.error('Error calculating price:', error);
            alert('Error calculating price. Please try again.');
        }
    });

}

async function loadLocationData() {
    console.log("loadLocationData");
    
    const formData = new FormData();
    formData.append('action', 'list-state');

    $.ajax({
        url: '/apps/integration',
        method: 'POST',
        data: formData,
        processData: false, // prevent jQuery from converting the data
        contentType: false, // let the browser set the correct content type
        success: function(response) {
            console.log('Location data loaded:', response);
            if (response.api === true) {
                // Store the location data globally
                window.tradeinDeviceData.locationData = response.data;
                console.log('Location data stored:', window.tradeinDeviceData.locationData);
                // Now render the location step after data is loaded
                setStep(4);
            } else {
                console.error('Location data loading failed:', response.msg);
                alert('Location data loading failed: ' + response.msg);
            }
        },
        error: function(xhr, status, error) {
            console.error('Error loading location data:', error);
        }
    });

}

async function createOrder(orderPayload) {
    console.log("createOrder", orderPayload);
    const formData = new FormData();
    formData.append('action', 'create-order');
    formData.append('quotationID', orderPayload.quotationID);
    formData.append('deviceID', orderPayload.deviceID);
    formData.append('price', orderPayload.price);
    formData.append('appointmentDate', orderPayload.appointmentDate);
    formData.append('fullName', orderPayload.fullName);
    formData.append('contactNumber', orderPayload.contactNumber);
    formData.append('email', orderPayload.email);
    formData.append('state', orderPayload.state);
    formData.append('town', orderPayload.town);
    formData.append('area', orderPayload.area);
    formData.append('zip', orderPayload.zip);
    formData.append('address', orderPayload.address);

    $.ajax({
        url: '/apps/integration',
        method: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        success: function(response) {
            console.log('Create order response:', response);
            if (response.api === true) {
                window.tradeinDeviceData.orderResult = response.data; // expects { po: "..." }
                setStep(5);
            } else {
                console.error('Create order failed:', response.msg);
                alert('Create order failed: ' + response.msg);
            }
        },
        error: function(xhr, status, error) {
            console.error('Error creating order:', error);
            console.error('XHR Status:', xhr.status);
            console.error('XHR Response:', xhr.responseText);
            alert('Error creating order. Please try again.');
        }
    });
}


// Dynamic start button binding based on #tradein data-button (e.g., "for=start-trade-in")
$(function () {
    var $tradeinRoot = $('#tradein');
    if ($tradeinRoot.length) {
        var dataButton = $tradeinRoot.attr('data-button');
        if (dataButton && dataButton.indexOf('=') !== -1) {
            var parts = dataButton.split('=');
            var attrName = $.trim(parts[0]);
            var attrValue = $.trim(parts.slice(1).join('='));
            if (attrName && attrValue) {
                $(document).off('click.tradeinStart');
                $(document).on('click.tradeinStart', '*[' + attrName + '="' + attrValue + '"]', function (e) {
                    // e.preventDefault();
                    loadBrandList();
                });
            }
        }
    }
});


// Dummy data removed - now using real API response

    // Helper function to create price calculation payload
    function createPriceCalculationPayload() {
        const deviceData = window.tradeinDeviceData.selectedDevice;
        const questionnaireAnswers = window.tradeinDeviceData.questionnaireAnswers;
        
        // Map question IDs to the expected format
        const questionMapping = {
            'turn_on': 'turnOn',
            'green_screen': 'greenScreen', 
            'severe_problem': 'severeProblem',
            'normal_problem': 'normalProblem',
            'scratch': 'scratch'
        };
        
        const payload = {
            action: "calculate-price",
            deviceID: deviceData.device_id,
            question: {}
        };
        
        // Map the questionnaire answers to the expected format
        Object.keys(questionnaireAnswers).forEach(questionId => {
            const mappedKey = questionMapping[questionId];
            if (mappedKey) {
                payload.question[mappedKey] = questionnaireAnswers[questionId];
            }
        });
        
        return payload;
    }

    // Helper: set step and render
    function setStep(step) {
        $('#tradein').attr('data-step', step);
        renderStep(step);
    }

    // Helper: render each step
    function renderStep(step) {
        if (step == 1) {
            // Device info form
            // Get the brand data from the global variable
            const brandData = window.tradeinDeviceData.brandList || { brands: [], models: {}, variants: {} };
            const previouslySelected = window.tradeinDeviceData.selectedDevice || {};
            // Extract brands from the new structure
            const brands = brandData.brands || [];
            const selectedBrand = previouslySelected.brand && brands.includes(previouslySelected.brand) ? previouslySelected.brand : '';
            const brandOptions = `<option value="" disabled ${!selectedBrand ? 'selected' : ''}>Select</option>` + brands.map(brand => `<option value="${brand}" ${brand === selectedBrand ? 'selected' : ''}>${brand}</option>`).join('');

            const modelsForBrand = brandData.models[selectedBrand] || [];
            const selectedModel = previouslySelected.model && modelsForBrand.includes(previouslySelected.model) ? previouslySelected.model : '';
            const modelOptions = `<option value="" disabled ${!selectedModel ? 'selected' : ''}>Select</option>` + modelsForBrand.map(model => `<option value="${model}" ${model === selectedModel ? 'selected' : ''}>${model}</option>`).join('');

            const variantsForModel = brandData.variants[selectedBrand] && brandData.variants[selectedBrand][selectedModel] ? brandData.variants[selectedBrand][selectedModel] : [];
            const variantCapacities = variantsForModel.map(v => v.capacity);
            const selectedVariant = previouslySelected.variant && variantCapacities.includes(previouslySelected.variant) ? previouslySelected.variant : '';
            const variantOptions = `<option value="" disabled ${!selectedVariant ? 'selected' : ''}>Select</option>` + variantCapacities.map(variant => `<option value="${variant}" ${variant === selectedVariant ? 'selected' : ''}>${variant}</option>`).join('');

            // Ensure selectedDevice is in sync and has device_id
            if (variantsForModel.length > 0) {
                const variantData = variantsForModel.find(v => v.capacity === selectedVariant) || variantsForModel[0];
                window.tradeinDeviceData.selectedDevice = {
                    brand: selectedBrand,
                    model: selectedModel,
                    variant: variantData.capacity,
                    device_id: variantData.device_id,
                    price: variantData.price,
                    currency: variantData.currency
                };
            }

            $('#tradein').html(`
                <div class="tradein-popup-overlay">
                    <div class="tradein-popup">
                        <button class="tradein-close">
                            <span class="modal-close-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M12.12,10l4.07-4.06a1.5,1.5,0,1,0-2.11-2.12L10,7.88,5.94,3.81A1.5,1.5,0,1,0,3.82,5.93L7.88,10,3.81,14.06a1.5,1.5,0,0,0,0,2.12,1.51,1.51,0,0,0,2.13,0L10,12.12l4.06,4.07a1.45,1.45,0,0,0,1.06.44,1.5,1.5,0,0,0,1.06-2.56Z"></path>
                                </svg>
                            </span>
                        </button>
                        <h2>Trade-in your device</h2>
                        <p class="tradein-subtitle">Get up to RM3,945 towards your new device.</p>
                        <form id="tradein-form">
                            <label>Brand:
                                <select name="brand" required>
                                    ${brandOptions}
                                </select>
                            </label>
                            <label>Product Model:
                                <select name="model" required>
                                    ${modelOptions}
                                </select>
                            </label>
                            <label>Product Variant:
                                <select name="variant" required>
                                    ${variantOptions}
                                </select>
                            </label>
                            <div class="tradein-actions">
                                <button type="button" class="tradein-next">Next</button>
                            </div>
                        </form>
                    </div>
                </div>
            `);
        } else if (step == 2) {
            // Questionnaire
            const questions = window.tradeinDeviceData.questionnaire?.questionnaire_template || [];
            const answers = window.tradeinDeviceData.questionnaireAnswers || {};
            let qHtml = `
              <div class="tradein-popup-overlay">
                <div class="tradein-popup">
                    <button class="tradein-close">
                        <span class="modal-close-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                            <path d="M12.12,10l4.07-4.06a1.5,1.5,0,1,0-2.11-2.12L10,7.88,5.94,3.81A1.5,1.5,0,1,0,3.82,5.93L7.88,10,3.81,14.06a1.5,1.5,0,0,0,0,2.12,1.51,1.51,0,0,0,2.13,0L10,12.12l4.06,4.07a1.45,1.45,0,0,0,1.06.44,1.5,1.5,0,0,0,1.06-2.56Z"></path>
                            </svg>
                        </span>
                    </button>
                  <form id="tradein-questionnaire">
                    <h2>Tell us about your device</h2>
            `;
            questions.forEach((q, idx) => {
                qHtml += `<div class="tradein-question-block">
                    <div class="tradein-question-title">
                      <span>${idx + 1}. </span>${q.question_title_en}
                    </div>
                    <div class="tradein-question-answers">`;
                q.answers.forEach(ans => {
                    const isSelected = answers[q.question_id] === ans.answer_value;
                    const selectedClass = isSelected ? ' selected' : '';
                    qHtml += `
                      <button type="button" 
                        class="tradein-answer-btn${selectedClass}" 
                        data-qid="${q.question_id}" 
                        data-ans="${ans.answer_id}"
                        data-answer-value="${ans.answer_value}">
                        ${ans.answer_title_en}
                      </button>
                    `;
                });
                qHtml += `</div></div>`;
            });
            qHtml += `
                    <div class="tradein-actions">
                      <button type="button" class="tradein-back tradein-secondary">Back</button>
                      <button type="button" class="tradein-next">Next</button>
                    </div>
                  </form>
                </div>
              </div>
            `;
            $('#tradein').html(qHtml);
        } else if (step == 3) {
            // Trade-in value
            const priceResult = window.tradeinDeviceData.priceResult;
            const selectedDevice = window.tradeinDeviceData.selectedDevice;
            const price = priceResult?.price || 0;
            const currency = selectedDevice?.currency || 'MYR';
            const grade = priceResult?.grade || '';
            
            $('#tradein').html(`
                <div class="tradein-popup-overlay">
                    <div class="tradein-popup">
                        <button class="tradein-close">
                            <span class="modal-close-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M12.12,10l4.07-4.06a1.5,1.5,0,1,0-2.11-2.12L10,7.88,5.94,3.81A1.5,1.5,0,1,0,3.82,5.93L7.88,10,3.81,14.06a1.5,1.5,0,0,0,0,2.12,1.51,1.51,0,0,0,2.13,0L10,12.12l4.06,4.07a1.45,1.45,0,0,0,1.06.44,1.5,1.5,0,0,0,1.06-2.56Z"></path>
                                </svg>
                            </span>
                        </button>
                        <h2>Trade-in your device</h2>
                        <div style="margin: 32px 0 16px 0;">
                            <div style="font-size: 1.2rem; font-weight: 500; margin-bottom: 8px;letter-spacing: 0;">
                                Your trade-in value
                            </div>
                            <div style="font-size: 32px; line-height:36px; font-weight: 700; color: #007aff; letter-spacing: 0;">
                                Up to ${currency}${price}
                                
                            </div>
                            ${grade ? `<div style="font-size: 16px; line-height: 20px; color: #666; margin-top: 8px; letter-spacing: 0;display:none;">
                                Device Grade: <strong>${grade}</strong>
                            </div>` : ''}
                            <div style="font-size: 16px; line-height: 20px; color: #444; margin-top: 12px; letter-spacing: 0;">
                                *The trade in value may change according to the actual condition<br>
                                of the device after second diagnostic in store.
                            </div>
                        </div>
                        <div class="tradein-actions">
                            <button type="button" class="tradein-back tradein-secondary">Back</button>
                            <button type="button" class="tradein-next">Accept</button>
                        </div>
                    </div>
                </div>
            `);
        } else if (step == 4) {
            // Combined Personal detail + Location selection step
            const locationData = window.tradeinDeviceData.locationData || { states: [], towns: {}, areas: {} };
            const savedLoc = window.tradeinDeviceData.selectedLocation || {};
            const savedPersonal = window.tradeinDeviceData.personalDetails || {};
            const states = locationData.states || [];
            const selectedState = savedLoc.state && states.includes(savedLoc.state) ? savedLoc.state : '';
            const townsForState = (locationData.towns && selectedState) ? (locationData.towns[selectedState] || []) : [];
            const selectedTown = savedLoc.town && townsForState.includes(savedLoc.town) ? savedLoc.town : '';
            const areasForTown = (locationData.areas && selectedState && selectedTown && locationData.areas[selectedState]) ? (locationData.areas[selectedState][selectedTown] || []) : [];
            const selectedArea = savedLoc.area && areasForTown.includes(savedLoc.area) ? savedLoc.area : '';

            const stateOptions = `<option value="" disabled ${!selectedState ? 'selected' : ''}>Select</option>` + states.map(state => `<option value="${state}" ${state === selectedState ? 'selected' : ''}>${state}</option>`).join('');
            const townOptions = `<option value="" disabled ${!selectedTown ? 'selected' : ''}>Select</option>` + townsForState.map(town => `<option value="${town}" ${town === selectedTown ? 'selected' : ''}>${town}</option>`).join('');
            const areaOptions = `<option value="" disabled ${!selectedArea ? 'selected' : ''}>Select</option>` + areasForTown.map(area => `<option value="${area}" ${area === selectedArea ? 'selected' : ''}>${area}</option>`).join('');

            // Persist normalized selected location
            if (selectedState) {
                window.tradeinDeviceData.selectedLocation = {
                    state: selectedState,
                    town: selectedTown || '',
                    area: selectedArea || ''
                };
            }

            $('#tradein').html(`
                <div class="tradein-popup-overlay">
                    <div class="tradein-popup">
                        <button class="tradein-close">
                            <span class="modal-close-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M12.12,10l4.07-4.06a1.5,1.5,0,1,0-2.11-2.12L10,7.88,5.94,3.81A1.5,1.5,0,1,0,3.82,5.93L7.88,10,3.81,14.06a1.5,1.5,0,0,0,0,2.12,1.51,1.51,0,0,0,2.13,0L10,12.12l4.06,4.07a1.45,1.45,0,0,0,1.06.44,1.5,1.5,0,0,0,1.06-2.56Z"></path>
                                </svg>
                            </span>
                        </button>
                        <form id="tradein-personal-form">
                            <h2 style="margin-bottom:24px;">Personal & Location</h2>
                            <label style="display:block;margin-bottom:16px;">
                                Full name
                                <input type="text" name="full_name" class="tradein-input" value="${savedPersonal.full_name || ''}" style="width:100%;padding:10px;margin-top:6px;border-radius:5px;border:1px solid #ccc;">
                            </label>
                            <label style="display:block;margin-bottom:16px;">
                                Contact number
                                <input type="text" name="contact_number" class="tradein-input" value="${savedPersonal.contact_number || ''}" style="width:100%;padding:10px;margin-top:6px;border-radius:5px;border:1px solid #ccc;">
                            </label>
                            <label style="display:block;margin-bottom:16px;">
                                Email
                                <input type="email" name="email" class="tradein-input" value="${savedPersonal.email || ''}" style="width:100%;padding:10px;margin-top:6px;border-radius:5px;border:1px solid #ccc;">
                            </label>
                            <label style="display:block;margin-bottom:16px;">
                                Address
                                <textarea name="address" class="tradein-input" style="width:100%;padding:10px;margin-top:6px;border-radius:5px;border:1px solid #ccc;min-height:48px;">${savedPersonal.address || ''}</textarea>
                            </label>
                            <label style="display:block;margin-bottom:24px;">
                                Postal code
                                <input type="text" name="postal_code" class="tradein-input" value="${savedPersonal.postal_code || ''}" style="width:100%;padding:10px;margin-top:6px;border-radius:5px;border:1px solid #ccc;">
                            </label>
                            <div class="location-select" style="display:flex;gap:12px;flex-wrap:wrap;margin-bottom:40px;">
                                <label>State:
                                    <select name="state" required>
                                        ${stateOptions}
                                    </select>
                                </label>
                                <label>Town:
                                    <select name="town" required>
                                        ${townOptions}
                                    </select>
                                </label>
                                <label>Area:
                                    <select name="area" required>
                                        ${areaOptions}
                                    </select>
                                </label>
                            </div>
                            <section class="terms-and-conditions">
                                <div style="font-size:14px; margin-bottom:5px;font-weight:600;line-height:20px;letter-spacing:0;">Please read the terms and conditions</div>
                                <ol style="list-style-position: inside;">
                                    <li>I certify that I am the legal owner of the item that I wish to sell.</li>
                                    <li>
                                    I acknowledge and agree that all prices offered by <span style="font-weight:600;">Remobie Technologies Sdn. Bhd.</span> (“Company”) through its website or other channels are preliminary only and may not represent the final evaluated price. The Company does not guarantee the final price until it has inspected the item. The Company reserves the right, in its sole discretion, to refuse to purchase any item offered for sale for any reason.
                                    </li>
                                    <li>
                                    I am solely responsible for deleting all data and information stored on the product(s) sold through the Company. I confirm that all such data and information will be deleted prior to delivery of the product. The Company shall not be held liable for any data or information that may remain on the product in any respect.
                                    </li>
                                    <li>
                                    Once the customer has received payment and the Company has received the product, the Company reserves the right not to return the product under any circumstances.
                                    </li>
                                    <li>
                                    The Company reserves the right to reject the product and withhold payment if the seller’s true identity does not match the identification document presented on the date the product is collected by the Company’s representative.
                                    </li>
                                    <li>
                                    I hereby consent to the Company and its partners collecting, using, and/or disclosing my personal data, including but not limited to my full name, age, national identification number, details from my identification card, telephone number, and information regarding my mobile phone or other electronic devices (including model name, color, IMEI number, and basic condition) (collectively, “Personal Data”), for the purpose of carrying out the trade-in program only (“Purpose”). I further consent to the Company retaining my Personal Data for as long as necessary to fulfill the Purpose.
                                    </li>
                                    <li>
                                    I confirm that the Personal Data provided to the Company is accurate and complete. I accept full responsibility for any loss or damage that may result from the provision of inaccurate or incorrect information.
                                    </li>
                                    <li>
                                    I acknowledge that if I do not provide consent for the collection, use, and/or disclosure of my Personal Data, the Company may be unable to fulfill its obligations to me in relation to the Purpose.
                                    </li>
                                    <li>
                                    I acknowledge that I have the right to withdraw my consent for the collection, use, and/or disclosure of my Personal Data at any time by notifying the Company in writing via email at <a href="mailto:support.my@remobie.com">support.my@remobie.com.</a>
                                    </li>
                                    <li>
                                    Any conditions or limitations on the number of rights to participate in the trade-in or trade-up program (if applicable), based on the number of new devices purchased, shall be determined solely by the seller of the new devices.
                                    </li>
                                </ol>
                            </section>
                            
                            <div style="display:flex;align-items:center;margin-bottom:24px; margin-top:12px;">
                                <input type="checkbox" id="tradein-terms" name="terms" ${savedPersonal.terms ? 'checked' : ''} style="margin-right:8px;">
                                <label for="tradein-terms" style="font-size:14px;">
                                    You agree to the <b>terms of sale</b>
                                </label>
                            </div>
                            
                            <div class="tradein-actions">
                                <button type="button" class="tradein-back tradein-secondary">Back</button>
                                <button type="button" class="tradein-next">Create trade-in order</button>
                            </div>
                        </form>
                    </div>
                </div>
            `);
        } else if (step == 5) {
            // Success page
            const orderResult = window.tradeinDeviceData.orderResult || {};
            const po = orderResult.po || '';
            $('#tradein').html(`
                <div class="tradein-popup-overlay">
                    <div class="tradein-popup">
                        <h2 style="margin-bottom:18px;">Success!</h2>
                        <div style="font-size:16px;margin-bottom:18px;">
                            Your trade-in order has been submitted.
                        </div>
                        ${po ? `<div style="font-size:20px;margin-bottom:12px;"><b>PO:</b> ${po}</div>` : ''}
                        <div style="font-size:14px;line-height:1.5;">
                            Our team will contact you via WhatsApp or phone call with your order details and instructions on how to ship your phone to us.
                        </div>
                    </div>
                </div>
            `);
        }
    }

    // Initial step will be called after API loads

    // Brand/model/variant change logic
    $('#tradein').off('change', 'select[name="brand"]');
    $('#tradein').on('change', 'select[name="brand"]', function() {
        const brandData = window.tradeinDeviceData.brandList || { brands: [], models: {}, variants: {} };
        const selectedBrand = $(this).val();
        const models = brandData.models[selectedBrand] || [];
        const modelOptions = models.map(model => `<option value="${model}">${model}</option>`).join('');
        $('select[name="model"]').html(modelOptions);

        // Update variants for the first model of the new brand
        const firstModel = models[0];
        const variants = brandData.variants[selectedBrand] && brandData.variants[selectedBrand][firstModel] ? 
            brandData.variants[selectedBrand][firstModel].map(variant => variant.capacity) : [];
        const variantOptions = variants.map(variant => `<option value="${variant}">${variant}</option>`).join('');
        $('select[name="variant"]').html(variantOptions);
        
        // Set the device_id for the first variant of the new brand/model
        if (brandData.variants[selectedBrand] && brandData.variants[selectedBrand][firstModel] && brandData.variants[selectedBrand][firstModel].length > 0) {
            const firstVariant = brandData.variants[selectedBrand][firstModel][0];
            window.tradeinDeviceData.selectedDevice = {
                brand: selectedBrand,
                model: firstModel,
                variant: firstVariant.capacity,
                device_id: firstVariant.device_id,
                price: firstVariant.price,
                currency: firstVariant.currency
            };
            console.log('Device updated for brand change:', window.tradeinDeviceData.selectedDevice);
        }
    });

    $('#tradein').off('change', 'select[name="model"]');
    $('#tradein').on('change', 'select[name="model"]', function() {
        const brandData = window.tradeinDeviceData.brandList || { brands: [], models: {}, variants: {} };
        const selectedBrand = $('select[name="brand"]').val();
        const selectedModel = $(this).val();
        const variants = brandData.variants[selectedBrand] && brandData.variants[selectedBrand][selectedModel] ? 
            brandData.variants[selectedBrand][selectedModel].map(variant => variant.capacity) : [];
        const variantOptions = variants.map(variant => `<option value="${variant}">${variant}</option>`).join('');
        $('select[name="variant"]').html(variantOptions);
        
        // Set the device_id for the first variant of the new model
        if (brandData.variants[selectedBrand] && brandData.variants[selectedBrand][selectedModel] && brandData.variants[selectedBrand][selectedModel].length > 0) {
            const firstVariant = brandData.variants[selectedBrand][selectedModel][0];
            window.tradeinDeviceData.selectedDevice = {
                brand: selectedBrand,
                model: selectedModel,
                variant: firstVariant.capacity,
                device_id: firstVariant.device_id,
                price: firstVariant.price,
                currency: firstVariant.currency
            };
            console.log('Device updated for model change:', window.tradeinDeviceData.selectedDevice);
        }
    });

    // Variant change handler to save device_id
    $('#tradein').off('change', 'select[name="variant"]');
    $('#tradein').on('change', 'select[name="variant"]', function() {
        const brandData = window.tradeinDeviceData.brandList || { brands: [], models: {}, variants: {} };
        const selectedBrand = $('select[name="brand"]').val();
        const selectedModel = $('select[name="model"]').val();
        const selectedCapacity = $(this).val();
        
        // Find the device_id for the selected variant
        const variantData = brandData.variants[selectedBrand] && brandData.variants[selectedBrand][selectedModel] ? 
            brandData.variants[selectedBrand][selectedModel].find(variant => variant.capacity === selectedCapacity) : null;
        
        if (variantData) {
            window.tradeinDeviceData.selectedDevice = {
                brand: selectedBrand,
                model: selectedModel,
                variant: selectedCapacity,
                device_id: variantData.device_id,
                price: variantData.price,
                currency: variantData.currency
            };
            console.log('Selected device updated:', window.tradeinDeviceData.selectedDevice);
        }
    });

    // Location change handlers
    $('#tradein').off('change', 'select[name="state"]');
    $('#tradein').on('change', 'select[name="state"]', function() {
        const locationData = window.tradeinDeviceData.locationData || { states: [], towns: {}, areas: {} };
        const selectedState = $(this).val();
        const towns = (locationData.towns && locationData.towns[selectedState]) ? locationData.towns[selectedState] : [];
        const townOptions = towns.map(town => `<option value="${town}">${town}</option>`).join('');
        $('select[name="town"]').html(townOptions);

        const firstTown = towns[0] || '';
        const areas = (locationData.areas && locationData.areas[selectedState] && firstTown) ? (locationData.areas[selectedState][firstTown] || []) : [];
        const areaOptions = areas.map(area => `<option value="${area}">${area}</option>`).join('');
        $('select[name="area"]').html(areaOptions);

        // Persist selection
        window.tradeinDeviceData.selectedLocation = {
            state: selectedState,
            town: firstTown || '',
            area: areas[0] || ''
        };
        console.log('Location updated (state change):', window.tradeinDeviceData.selectedLocation);

        // Remove duplicate options from the area select
        const seenAreas = {};
        $('select[name="area"] option').each(function() {
            const text = $(this).text();
            if (seenAreas[text]) {
                $(this).remove();
            } else {
                seenAreas[text] = true;
            }
        });
    });

    $('#tradein').off('change', 'select[name="town"]');
    $('#tradein').on('change', 'select[name="town"]', function() {
        const locationData = window.tradeinDeviceData.locationData || { states: [], towns: {}, areas: {} };
        const selectedState = $('select[name="state"]').val();
        const selectedTown = $(this).val();
        const areas = (locationData.areas && locationData.areas[selectedState] && selectedTown) ? (locationData.areas[selectedState][selectedTown] || []) : [];
        const areaOptions = areas.map(area => `<option value="${area}">${area}</option>`).join('');
        $('select[name="area"]').html(areaOptions);

        // Persist selection
        window.tradeinDeviceData.selectedLocation = {
            state: selectedState || '',
            town: selectedTown || '',
            area: areas[0] || ''
        };
        console.log('Location updated (town change):', window.tradeinDeviceData.selectedLocation);

        // Remove duplicate options from the area select
        const seenAreas = {};
        $('select[name="area"] option').each(function() {
            const text = $(this).text();
            if (seenAreas[text]) {
                $(this).remove();
            } else {
                seenAreas[text] = true;
            }
        });
    });

    $('#tradein').off('change', 'select[name="area"]');
    $('#tradein').on('change', 'select[name="area"]', function() {
        const selectedState = $('select[name="state"]').val();
        const selectedTown = $('select[name="town"]').val();
        const selectedArea = $(this).val();
        window.tradeinDeviceData.selectedLocation = {
            state: selectedState || '',
            town: selectedTown || '',
            area: selectedArea || ''
        };
        console.log('Location updated (area change):', window.tradeinDeviceData.selectedLocation);
    });

    // Next button logic
    $('#tradein').off('click', '.tradein-next');
    $('#tradein').on('click', '.tradein-next', function(e) {
        e.preventDefault();
        const step = parseInt($('#tradein').attr('data-step'), 10);

        if (step === 1) {
            // Save device selection - use the global device data
            const deviceSelection = window.tradeinDeviceData.selectedDevice;
            window.tradeinDeviceSelection = deviceSelection;
            // Load questions before going to step 2
            loadQuestion();
        } else if (step === 2) {
            // Validate: ensure all required questions are answered
            const questionnaire = window.tradeinDeviceData.questionnaire?.questionnaire_template || [];
            const requiredQids = questionnaire.filter(q => q.required).map(q => q.question_id);
            const questionnaireAnswers = window.tradeinDeviceData.questionnaireAnswers;

            const missingQids = requiredQids.filter(qid => questionnaireAnswers[qid] === undefined);
            // Clear any prev error
            $('.tradein-error').remove();
            if (missingQids.length > 0) {
                // Show error and stop
                $('#tradein-questionnaire .tradein-actions').before(`<div class="tradein-error" style="color:#d32f2f;margin-bottom:12px;">Please answer all questions before continuing.</div>`);
                return;
            }
            const deviceSelection = window.tradeinDeviceSelection || {};
            const tradeinResult = {
                device: deviceSelection,
                questionnaire: questionnaireAnswers
            };
            window.tradeinResult = tradeinResult;
            
            // Create and log the price calculation payload
            const priceCalculationPayload = createPriceCalculationPayload();
            console.log('Price calculation payload:', priceCalculationPayload);
            
            // Calculate price before going to step 3
            calculatePrice();
        } else if (step === 3) {
            // Load location data before going to step 4
            console.log('Step 3: About to call loadLocationData()');
            // let trade_in_details = document.querySelector('.product__title').innerText
            let closeBtn = document.querySelector('.tradein-close')
            function saveCookie(data, days = 7) {
                const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();

                Object.keys(data).forEach(key => {
                    document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}; expires=${expires}; path=/`;
                });
            }
            const trade_in_details = window.tradeinDeviceData.selectedDevice.model;
            const trade_in_amount = window.tradeinDeviceData.priceResult.price;
            const quotation_id = window.tradeinDeviceData.priceResult.quotation_id;
            const trade_in_details_el = document.querySelector('#trade_in_details')
            const trade_in_amount_el = document.querySelector('#trade_in_amount')
            const trade_in_quotation_id_el = document.querySelector('#trade_in_quotation_id')
            const trade_in_enable_el = document.querySelector('#trade_in_enable')
            trade_in_details_el.value = trade_in_details
            trade_in_amount_el.value = trade_in_amount
            trade_in_quotation_id_el.value = quotation_id
            trade_in_enable_el.value = "true"
            console.log('Trade-in details:', trade_in_details, trade_in_amount, quotation_id);
            // saveCookie({
            //     "_trade_in_enabled": "true",
            //     "_trade_in_details": trade_in_details,
            //     "_trade_in_amount": trade_in_amount,
            //     "_quotation_id": quotation_id
            // });
            closeBtn.click()
            //loadLocationData();
        } else if (step === 4) {
            // Validate personal + location, then create order
            const full_name = $('input[name="full_name"]').val().trim();
            const contact_number = $('input[name="contact_number"]').val().trim();
            const email = $('input[name="email"]').val().trim();
            const address = $('textarea[name="address"]').val().trim();
            const postal_code = $('input[name="postal_code"]').val().trim();
            const terms = $('#tradein-terms').is(':checked');
            const state = $('select[name="state"]').val();
            const town = $('select[name="town"]').val();
            const area = $('select[name="area"]').val();

            // Simple validation
            let errorMsg = '';
            if (!full_name || !contact_number || !email || !address || !postal_code || !state || !town || !area) {
                errorMsg = 'Please fill in all fields.';
            } else if (!terms) {
                errorMsg = 'You must agree to the terms of sale.';
            }

            // Show error if any
            $('.tradein-error').remove();
            if (errorMsg) {
                $('.tradein-actions').before(`<div class="tradein-error" style="color:#d32f2f;margin-bottom:12px;">${errorMsg}</div>`);
                return;
            }

            // Collect and submit
            const personalDetails = {
                full_name,
                contact_number,
                email,
                address,
                postal_code,
                terms
            };
            // Persist personal details
            window.tradeinDeviceData.personalDetails = personalDetails;
            // Persist location
            window.tradeinDeviceData.selectedLocation = { state, town, area };
            const tradeinResult = window.tradeinResult || {};

            // Build payload for create order per spec
            const selectedDevice = window.tradeinDeviceData.selectedDevice || {};
            const priceResult = window.tradeinDeviceData.priceResult || {};
            const selectedLocation = window.tradeinDeviceData.selectedLocation || {};

            // Simple appointment date: today (YYYY-MM-DD). Adjust later if needed.
            const today = new Date();
            const appointmentDate = today.toISOString().slice(0,10);

            const orderPayload = {
                quotationID: priceResult.quotation_id, // from calculate price
                deviceID: selectedDevice.device_id,     // from selection
                price: priceResult.price,               // from calculate price
                appointmentDate: appointmentDate,
                fullName: full_name,
                contactNumber: contact_number,
                email: email,
                state: selectedLocation.state,
                town: selectedLocation.town,
                area: selectedLocation.area,
                zip: postal_code,
                address: address
            };

            console.log('Create order payload:', orderPayload);
            createOrder(orderPayload);
        }
    });

    // Back button logic
    $('#tradein').off('click', '.tradein-back');
    $('#tradein').on('click', '.tradein-back', function(e) {
        e.preventDefault();
        const step = parseInt($('#tradein').attr('data-step'), 10);
        if (step === 2) {
            setStep(1);
        } else if (step === 3) {
            setStep(2);
        } else if (step === 4) {
            setStep(3);
        } else if (step === 5) {
            setStep(4);
        }
    });

    // Answer button selection logic (single select per question)
    $('#tradein').off('click', '.tradein-answer-btn');
    $('#tradein').on('click', '.tradein-answer-btn', function() {
        const qid = $(this).data('qid');
        const answerValue = $(this).data('answer-value');
        $(this).siblings(`[data-qid="${qid}"]`).removeClass('selected');
        $(this).addClass('selected');
        
        // Store the answer value globally
        window.tradeinDeviceData.questionnaireAnswers[qid] = answerValue;
        console.log('Question answer updated:', qid, '=', answerValue);
    });

    // Close handler
    $('#tradein').off('click', '.tradein-close, .tradein-popup-overlay');
    $('#tradein').on('click', '.tradein-close, .tradein-popup-overlay', function(e) {
        if ($(e.target).is('.tradein-close') || $(e.target).is('.tradein-popup-overlay') || $(e.target).closest('.tradein-close')) {
            $('#tradein').empty();
        }
    });

    // Prevent overlay click from closing when clicking inside popup
    $('#tradein').off('click', '.tradein-popup');
    $('#tradein').on('click', '.tradein-popup', function(e) {
        e.stopPropagation();
});